import React, { useEffect, useState } from 'react';
import RemoveStationIndividualSelection from './RemoveStationIndividualSelection'; // Ensure this path is correct
import './customization-remove-station.css';

export default function CustomizationRemoveStation({ listOfStationsToDisplay, removeStationClick }) {
  const [trainStationsList, setTrainStationsList] = useState([]);

  useEffect(() => {
    const localStorageTrainStationsList = localStorage.getItem('BusAndTrainList');
    if (localStorageTrainStationsList) {
      const stationStrings = localStorageTrainStationsList.split('&');
      const trainStationsArray = stationStrings.map(stationString => {
        const cleanedString = stationString.slice(1, -1);
        const [index, isBus, busNumber, id, name, busOrtrainColor, hex] = cleanedString.split(',');
        return {
          index: index,
          isBus: isBus,
          busNumber: busNumber,
          stopId: id,
          stopName: name,
          color: busOrtrainColor,
          colorHex: hex
        };
      });

      setTrainStationsList(trainStationsArray);
    }
  }, []);

  function removeStationFromRemoveList(stopId, color) {
    // // Remove from localStorage
    // let localStorageTrainStationsList = localStorage.getItem('TrainStationsList');
    // if (localStorageTrainStationsList) {
    //   const stationStrings = localStorageTrainStationsList.split('&');
    //   const updatedStationsArray = stationStrings.filter(stationString => {
    //     const cleanedString = stationString.slice(1, -1);
    //     const [id] = cleanedString.split(',');
    //     return id !== stationId;
    //   });
    //   localStorageTrainStationsList = updatedStationsArray.join('&');
    //   localStorage.setItem('TrainStationsList', localStorageTrainStationsList);
    // }

    // Remove from state
    setTrainStationsList(prevState => prevState.filter(station => station.stopId !== stopId || station.color !== color));
  }

  return (
    <div className='customization-remove-station-container'>
      <div className='customization-remove-station-title-container'>Select station to remove</div>
      <div className='customization-remove-station-list-container'>
        {listOfStationsToDisplay.length === 0 ? (
          <p>No stations available</p>
        ) : (
          listOfStationsToDisplay.map((stop, index) => (
            <RemoveStationIndividualSelection
              key={index}
              stopId={stop.stopOrStationId}
              stopName={stop.stopOrStationName}
              color={stop.color}
              colorHex={stop.colorHex}
              removeStationFunctionCalls={() => {
                removeStationClick(stop.stopOrStationId, stop.color);
                removeStationFromRemoveList(stop.stopOrStationId, stop.color);
              }}
            />
          ))
        )}
      </div>
    </div>
  );
}
